import { all, call, put, takeEvery } from 'redux-saga/effects'
import { globalLoaderText } from "redux/CommonDashboard/actions";
import { setRegion } from 'Store/Organization/Region/RegionAction';
import { GET_REGIONS } from 'Store/Organization/Region/RegionType';
import { apiMethod, apiType, API_URL } from 'utils';
import OrganizationApiService from './OrganizationApiService';
import { IPayload } from 'Model/IPayload';

function* getRegion(): any {
    let payloadData : IPayload = {                
        apiMethod : apiMethod.GET,
        apiType : apiType.Organization,
        endpoint : `organizations/dropdown/regions`,   
        payload : null    
    }
    try {
        yield put(globalLoaderText("Fetching Data...."));
        const response = yield call(
            OrganizationApiService.post,
            API_URL.PostWebApp, payloadData
        );
        yield put(setRegion(response));
        yield put(globalLoaderText(""));
    } catch (error) {
        console.log(error);
        yield put(globalLoaderText(""));
    }
}

function* watchGetStates() {
    yield takeEvery(GET_REGIONS, getRegion)
}

export default function* combinedSaga() {
    yield all([
        watchGetStates()
    ])
}
